function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_42",
  transform: "translate(-15.625 93.75)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_468",
  d: "M94.2-60.9h-8.6v-8.6c0-0.8-0.3-1.5-0.8-2c-0.5-0.5-1.3-0.8-2-0.8h-8.6v-8.6c0-0.8-0.3-1.5-0.8-2 c-0.5-0.5-1.3-0.8-2-0.8H37c-1.6,0-2.9,1.3-2.9,2.9v51.4c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.3,0.8,2,0.8h8.6v8.6c0,0.8,0.3,1.5,0.8,2 c0.5,0.5,1.3,0.8,2,0.8h8.6v8.6c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.3,0.8,2,0.8h34.3c0.8,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.3,0.8-2V-58 c0-0.8-0.3-1.5-0.8-2C95.7-60.6,95-60.9,94.2-60.9L94.2-60.9z M39.9-78h28.6v45.7H39.9V-78z M51.3-26.6h20c0.8,0,1.5-0.3,2-0.8 c0.5-0.5,0.8-1.3,0.8-2v-37.1h5.7v45.7H51.3V-26.6z M91.3-9.4H62.8v-5.8h20c0.8,0,1.5-0.3,2-0.8c0.5-0.5,0.8-1.3,0.8-2v-37.1h5.7 L91.3-9.4z"
}));

var SvgICards = function SvgICards(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Vrstva_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgICards, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/i_cards.0327b15c.svg";
export { ForwardRef as ReactComponent };